import React, { Component } from "react";
import { Link } from "react-router";
import { Table } from "antd";
import momemt from "moment";

class TableOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  columns = () => {
    let config = [
      {
        title: "流程类型",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "标题",
        dataIndex: "title",
        key: "title",
        render: (text, record) => {
          switch (record.type) {
            case "":
              return <Link to="">{text}</Link>;
            default:
              return <span>{text}</span>;
          }
        },
      },
      {
        title: "申请人",
        dataIndex: "createUserName",
        key: "createUserName",
      },
      {
        title: "申请时间",
        dataIndex: "createTime",
        key: "createTime",
        render: (text, record) => {
          return <span>{momemt(text).format("YYY-MM-DD")}</span>;
        },
      },
      {
        title: "当前环节-处理人",
        dataIndex: "instance",
        key: "instance",
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          const { name, processorName } = currentActivity;
          return (
            <span>
              {currentActivity.uuid
                ? `${name || ""}-${processorName || ""}`
                : ""}
            </span>
          );
        },
      },
      {
        title: "流程状态",
        dataIndex: "status",
        key: "status",
        render: (text, record) => {
          switch (text) {
            case 0:
              return "审核中";
            case 1:
              return "已完成";
            default:
              return "待编辑";
          }
        },
      },
    ];

    if (this.props.type !== "all") {
      config = config.filter(item => item.dataIndex !== "status");
    }

    return config;
  };

  render() {
    const pagination = {
      pageSize: this.pageSize,
      current: this.current,
      total: this.total,
    };
    return (
      <Table
        columns={this.columns()}
        dataSource={this.props.data}
        pagination={pagination}
      />
    );
  }
}

export default TableOrg;



// WEBPACK FOOTER //
// ./src/components/flow/TableOrg.js